import { FC } from 'react';
import { useStyles } from './styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { observer } from 'mobx-react-lite';
import { Paper } from '@material-ui/core';

export const BillingTable: FC = observer(() => {
  const classes = useStyles();
  return (
    <Paper className={classes.container}>
      <div style={{ marginTop: '0px' }} className={classes.header}>
        <div className={classes.mainHeading}>Billing</div>
      </div>
      <TableContainer>
        <Table aria-label='simple table'>
          <TableHead>
            <TableCell className={`${classes.border} ${classes.cellHeader}`}>Plan</TableCell>
            <TableCell className={`${classes.border} ${classes.cellHeader}`}>Description</TableCell>
            <TableCell className={`${classes.border} ${classes.cellHeader}`}>Price/User - Paid Monthly</TableCell>
            <TableCell className={`${classes.border} ${classes.cellHeader}`}>Price/User - Paid Yearly</TableCell>
          </TableHead>
          <TableBody>
            {/* <TableHead> */}
            <TableRow>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                Premium Support <br /> (optional)
              </TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}></TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>$x</TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>$y</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                Total Number of Users <br /> (mandatory)
              </TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>input from customer</TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}></TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                Edu/Non-Profit/Gov Entity <br /> (mandatory)
              </TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>Yes/No (default)</TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}></TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>
                Additional Discount Code <br /> (optional)
              </TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>input field</TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}></TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>Total Price</TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}></TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>$25</TableCell>
              <TableCell className={`${classes.border} ${classes.cellTitle}`}>$30</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
});
